import React from "react";
import ScriptLogo from "../assets/images/script-logo.svg";
import HandLogo from "../assets/images/hand-logo.svg";
import filterLab from "../assets/images/filter-icon.svg";

const MainComponent = ({ layerHandler, objectionLayer }) => {
  return (
    <div className="container cl-main-container">
      <div className="card p-3 bg-transparent cl-main-card">
        <div>
          <div className="card cl-secondary-card">
            <div className="card-body p-4">
              <div className="cl-filter-icon">
                <span>
                  <img className="img-fluid" src={filterLab} alt="Filter" />
                </span>
                <label>Conversion Lab</label>
                <hr className="cl-heading-border" />
              </div>
              <div className="form-floating mt-3">
                <div className="text-center cl-internal-area-container main-box">
                  <div>
                    <button
                      onClick={layerHandler}
                      type="button"
                      className="btn cl-stretched-link"
                    >
                      <img
                        className="img-fluid"
                        src={ScriptLogo}
                        alt="Script Logo"
                      />
                    </button>
                    <p className="card-text mt-2 cl-stretched-pra">Script</p>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={objectionLayer}
                      className="btn cl-stretched-link"
                    >
                      <img
                        className="img-fluid"
                        src={HandLogo}
                        alt="Hand Logo"
                      />
                    </button>
                    <p className="card-text mt-2 cl-stretched-pra">
                      Objections
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer border-0 bg-transparent pb-5 pt-1"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainComponent;
